import {ErrorHandler, Injectable, Injector} from '@angular/core';
import { ApplicationInsightsService } from './services/application-insights.service';
// import { FlowManagementService } from './services/flow-management.service';

@Injectable()
export class CustomErrorHandler extends ErrorHandler {
    constructor(private injector: Injector){
        super();
    }
 
    public handleError(error: any): void {
        // You can add your own logic here.
        // It is not required to delegate to the original implementation

        if (error?.name === 'EmptyError') {
            // EmptyError: "no elements in sequence" — thrown by firstValueFrom() or first()
            // when the source observable completes without emitting a value.
            // Common causes: MSAL interceptor returning EMPTY during redirect,
            // or an HTTP call to a protected endpoint failing silently.
            // Check payment.service.ts and context.service.ts for firstValueFrom() calls.
            console.group('%c[DEBUG] EmptyError caught in handleError', 'color: orange; font-weight: bold');
            console.warn('Source: likely firstValueFrom() called on an observable that completed without emitting.');
            console.warn('Candidates: payment.service.ts:66 (getSubscription), context.service.ts:38 (getAccessTokenSilent$)');
            console.error('Original error:', error);
            console.groupEnd();
        }

        const monitoringService = this.injector.get(ApplicationInsightsService);
        monitoringService.trackError(error);

        super.handleError(error);
    }
}